import {
  BookingRelocationMatchType,
  BookingStatus,
  RelocationType,
} from "@/gql/graphql";

export type BookingTableState = {
  statuses: BookingStatus[];
  supplierId: string | null;
  departureCityIds: string[];
  deliveryCityIds: string[];
  vehicles: string[];
  relocationTypes: RelocationType[];
  hasMatches: BookingRelocationMatchType | null;
  page: number;
  search: string;
};

export const defaultBookingTableState: BookingTableState = {
  statuses: [],
  supplierId: null,
  departureCityIds: [],
  deliveryCityIds: [],
  vehicles: [],
  relocationTypes: [],
  hasMatches: null,
  page: 1,
  search: "",
};
